import { t } from "i18next";
import { Trans } from "react-i18next";

import styles from "./Modal.module.scss";
import { Button, Icon } from "@livingmap/hippo";

interface Props {
  featureName: string | undefined;
  closeModal: () => void;
  onDelete: () => void;
}

const Delete: React.FC<Props> = ({ featureName, closeModal, onDelete }) => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <h5 className={styles.title}>{t("modals.archive.title")}</h5>
        <button className={styles.closeButton} onClick={closeModal}>
          <Icon dataQA="close-icon" name="close" size={18} />
        </button>
      </div>
      <div className={styles.contentContainer}>
        <p className={styles.description}>
          <Trans i18nKey="modals.archive.description" values={{ featureName }}>
            <span />
          </Trans>
        </p>
        <div className={styles.buttonWrapper}>
          <Button
            dataQA="cancel-button"
            type="primary"
            size="regular"
            style="filled"
            text={t("btn_labels.cancel")}
            onClick={closeModal}
          />
          <Button
            dataQA="delete-button"
            type="negative"
            size="regular"
            style="filled"
            text={t("modals.archive.btn_labels.archive")}
            onClick={onDelete}
          />
        </div>
      </div>
    </div>
  );
};

export default Delete;
